export default function Logo({ light = false, full = true, className = "" }) {
  const file = full
    ? light ? "/assets/logo-white.png" : "/assets/logo.png"
    : light ? "/assets/logo-compact-white.png" : "/assets/logo-compact.png";
  const size = full ? "h-12 sm:h-14" : "h-9 sm:h-10";
  return (
    <img
      src={file}
      alt="ARMS Ltd — Changing Attitudes, Behaviours & Culture"
      className={`w-auto ${size} ${className}`}
    />
  );
}
